module.exports = __webpack_public_path__ + "img/nav-info-home-act.4419fb7f.png";